<template lang="pug">
  l-map(ref='map' style='min-height: 100vmin; min-height: 100vh;' :zoom='zoom' :center='center' :bounds="globalBounds")
    template(v-if="projects && projects.length")
      l-tile-layer(
          v-for="({ url, attribution, visible, name }) in layers"
          :url="url"
          :attribution="attribution"
          :visible="visible"
          :key="`tile-layer-${name}`"
        )
      l-marker(
          :lat-lng="getMarkerPositionByLatLng(item.projectInfo, { lat: item.longitude, lng: item.latitude }, item)" v-for="item in projects"
          :key="item.id"
          @click="goToShowProject(item.id)"
          :icon="buildSmallIcon(item)"
        )
        l-tooltip(:content="popupProject(item)")
      l-geo-json(
        v-for="({ id, geoJson, mapProperties }) in projectShapes"
        :geojson="geoJson"
        :options="mapProperties"
        :key="`shape-${id}`"
      )

</template>

<script>
import { mapGetters } from 'vuex'
import { buildSmallIcon } from '@/utils/map-utils.js'
import mapMixin from '@/mixins/map.js'
import RedmineApiService from '@/services/redmine-api.js'
import ProjectService from '@/services/projects.js'

const REDMINE_SERVER_URL = process.env.VUE_APP_REDMINE_BASE_URL

export default {
  mixins: [ mapMixin ],
  props: {
    msg: String
  },
  data () {
    return {
      projects: [],
      projectShapes: []
    }
  },
  mounted () {
    // Add reference to the map
    const token = this.$route.query.token
    if (token) {
      RedmineApiService.getProjectsWithIssues(this.$http, token)
        .then(projects => {
          this.dataWithShapesByProjectList(projects.map(p => p.projectInfo)).then(data => {
            this.projectShapes = data
            projects.forEach(p => {
              p.projectInfo = data.find(d => d.code === p.projectInfo.code)
            })
            this.projects = projects
            this.setGlobalBounds()
          })
        })
        .catch(err => {
          console.error(err)
        })
    } else {
      console.error('Error: token no recibido')
    }
  },
  methods: {
    getMarkerPositionByLatLng: ProjectService.getMarkerPositionByLatLng,
    goToShowIssue (issueId) {
      window.parent.location.href = `${REDMINE_SERVER_URL}issues/${issueId}`
    },
    goToShowProject (projectCode) {
      window.parent.location.href = `${REDMINE_SERVER_URL}projects/${projectCode}/issues?set_filter=1&tracker_id=1`
    },
    popupIssue (issue) {
      return `
        <h3>${issue.subject}</h3>
        <p>${issue.description}</p>
      `
    },
    popupProject (project) {
      return `
        <h3>${project.name}</h3>
        <p><strong>Cantindad de reclamos: </strong> ${project.issues.length}
      `
    },
    buildSmallIcon ({ issues, projectInfo }) {
      const { color, number } = projectInfo
      return buildSmallIcon({ color, number, extraSlot: `<span class="project-issues-amount">${issues.length}</span>` })
    }
  },
  computed: {
    ...mapGetters(['dataWithShapesByProjectList'])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import '~@/styles/variables'

h3 {
  margin: $f40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 $f10px;
}
a {
  color: #42b983;
}
</style>
<style lang="stylus">
@import '~@/styles/variables'

.project-issues-amount {
  font-size: $f14px;
  position: absolute;
  border-radius: 50%;
  width: $f18px;
  height: $f18px;
  background: white;
  top: - $f3px;
  right: $f4px;
  text-align: center;
  padding: $f2px;
}
</style>
